module.exports = __webpack_public_path__ + "img/Vanuatu.b4c60794.png";